import type { Card } from '../../types';

/** §14 worked card (ADR-0015 §17 mapping). Passive: when the opponent applies a
 * status to you, apply the same status back to them. Max once per turn. */
export const MIRROR: Card = {
  id: 'mirror',
  name: 'Mirror',
  type: 'trap',
  rarity: 'epic',
  size: { w: 2, h: 2 },
  cost: [],
  effects: [{ kind: 'mirrorStatus' }],
  trap: {
    variant: 'passive',
    trigger: { kind: 'opponentAppliesStatus' },
    maxFiresPerTurn: 1,
  },
};
